import { CanDeactivateFn } from '@angular/router';
import { FormsComponent } from '../containers/forms/forms.component';

export const unsavedChangesGuard: CanDeactivateFn<FormsComponent> = (component) => {
    return component.canDeactivate();
};
